import { JugglingScreen } from "@motley/design"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(user)/(tenantBc)/prompts/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <JugglingScreen />
}
